import { useUserStore } from "@/game/logic/useUserStore";

export function useJWT() {
  const user = useUserStore.getState().user;
  return user.jwt;
}
